export default __webpack_public_path__ + "static/beanie-2c51e7977bdb425cb4e8b32e5439768c.jpg";